import { createApiSlice } from 'app/createApiSlice'
import moment from 'moment-timezone'
import {
  API_ADJUSTMENT_GET_DRAFT,
  API_ADJUSTMENT_SET_DRAFT,
  API_EDIT_NO_TRX,
  API_EDIT_PROJECT,
  API_SELLER_CONFIRM_PAYMENT_COD,
  API_TRANSACTION_PAYMENT,
  API_TRANSACTION_ARCHIVE,
} from 'utils/apiList'

export const dashboardApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'dashboard/hooks',
  endpoints(builder) {
    return {
      fetchSaldo: builder.query({
        query() {
          return `/api/v1/bussines/saldo`
        },
        transformErrorResponse({ data, status }) {
          return {
            data,
            status,
          }
        },
      }),
      fetchTransaction: builder.query({
        query(args) {
          const {
            type,
            size,
            page,
            status,
            payment,
            sortdir,
            sortby,
            forSellerProcessing,
            from,
            to,
            s,
            code,
            id,
            trxType,
            projectId,
            filtertype,
            filtertypevalue,
            filterPicUserId,
            allitem,
          } = args
          const params = {
            type,
            size,
            page,
            sortdir,
            sortby,
            forSellerProcessing,
            s: s,
          }
          if (status !== undefined) params.status = status
          if (payment !== undefined) params.payment = payment
          if (from && from !== '') {
            params.from = moment(from).toISOString()
          }
          if (to && to !== '') {
            params.to = moment(to).endOf('day').toISOString()
          }
          if (filterPicUserId !== undefined) {
            params.filterPicUserId = filterPicUserId
          }
          if (allitem !== undefined) {
            params.allitem = allitem
          }
          if (code !== undefined) params.code = code
          if (id !== undefined) params.id = id
          if (trxType !== undefined) params.trxType = trxType
          if (projectId !== undefined) params.projectId = projectId
          if (filtertype !== undefined) params.filtertype = filtertype
          if (filtertypevalue !== undefined) params.filtertypevalue = filtertypevalue
          return {
            url: '/api/v2/bussines/transaction-list',
            params,
          }
        },
      }),
      fetchTransactionSummary: builder.query({
        query(args) {
          const {
            type,
            size,
            page,
            status,
            payment,
            sortdir,
            sortby,
            forSellerProcessing,
            from,
            to,
            s,
            code,
            id,
            trxType,
            projectId,
            filtertype,
            filtertypevalue,
            filterPicUserId,
            allitem,
          } = args
          const params = {
            type,
            size,
            page,
            sortdir,
            sortby,
            forSellerProcessing,
            s: s,
          }
          if (status !== undefined) params.status = status
          if (payment !== undefined) params.payment = payment
          if (from && from !== '') {
            params.from = moment(from).toISOString()
          }
          if (to && to !== '') {
            params.to = moment(to).endOf('day').toISOString()
          }
          if (filterPicUserId !== undefined) {
            params.filterPicUserId = filterPicUserId
          }
          if (allitem !== undefined) {
            params.allitem = allitem
          }
          if (code !== undefined) params.code = code
          if (id !== undefined) params.id = id
          if (trxType !== undefined) params.trxType = trxType
          if (projectId !== undefined) params.projectId = projectId
          if (filtertype !== undefined) params.filtertype = filtertype
          if (filtertypevalue !== undefined) params.filtertypevalue = filtertypevalue
          return {
            url: '/api/v2/bussines/transaction-list-summary',
            params,
          }
        },
      }),
      fetchTransactionPic: builder.query({
        query(args = {}) {
          const {
            page = 0,
            size = 20,
            s,
            searchPicName,
            code,
            id,
            sortby = 'name',
            sortdir = 'asc',
            type,
            from,
            to,
            payment,
            status,
            forSellerProcessing,
            filtertype,
            filtertypevalue,
            trxType,
            projectId,
            filterPicUserId,
          } = args
          const params = {
            page,
            size,
            sortby,
            sortdir,
          }
          if (type !== undefined) params.type = type
          if (s !== undefined && s !== '') params.s = s
          if (searchPicName !== undefined && searchPicName !== '') {
            params.searchPicName = searchPicName
          }
          if (code !== undefined) params.code = code
          if (id !== undefined) params.id = id
          if (status !== undefined) params.status = status
          if (payment !== undefined) params.payment = payment
          if (from && from !== '') {
            params.from = moment(from).toISOString()
          }
          if (to && to !== '') {
            params.to = moment(to).endOf('day').toISOString()
          }
          if (forSellerProcessing !== undefined) {
            params.forSellerProcessing = forSellerProcessing
          }
          if (filtertype !== undefined) params.filtertype = filtertype
          if (filtertypevalue !== undefined) params.filtertypevalue = filtertypevalue
          if (trxType !== undefined) params.trxType = trxType
          if (projectId !== undefined) params.projectId = projectId
          if (filterPicUserId !== undefined) {
            params.filterPicUserId = filterPicUserId
          }
          return {
            url: '/api/v2/bussines/transaction-list-pic',
            params,
          }
        },
      }),
      fetchProfile: builder.query({
        query() {
          return `/api/v1/bussines/profile`
        },
      }),
      fetchNotif: builder.query({
        query({ page = 0, size = 10 }) {
          return `/api/v1/bussines/notification?page=${page}&size=${size}`
        },
      }),
      fetchInbox: builder.query({
        query({ page = 0, type, size = 10 }) {
          return `/api/v1/bussines/notification-news?page=${page}&type=${type}&size=${size}`
        },
      }),
      fetchReadInbox: builder.query({
        query(id) {
          return `/api/v1/bussines/notification-news/${id}/read`
        },
      }),
      fetchReadNotif: builder.mutation({
        query(id) {
          return {
            url: `/api/v1/bussines/notification/${id}/read`,
            method: 'POST'
          }
        },
      }),
      fetchReadAllNotif: builder.mutation({
        query() {
          return {
            url: `/api/v1/bussines/notification/read-all`,
            method: 'POST'
          }
        },
      }),
      fetchTransactionById: builder.query({
        query({ id, escrowpaymentId, tradeshortcutId }) {
          const params = {}
          if (escrowpaymentId) {
            params.escrowpaymentId = escrowpaymentId
          } else if (tradeshortcutId) {
            params.tradeshortcutId = tradeshortcutId
          } else if (id) {
            params.escrowpaymentId = id
          }
          return {
            url: `/api/v2/bussines/transaction-detail`,
            params,
          }
        },
      }),
      fetchTransactionItemDetail: builder.query({
        query({ escrowpaymentId, tradeshortcutId, id, type }) {
          const params = {}
          if (type) params.type = type

          if (escrowpaymentId) {
            params.escrowpaymentId = escrowpaymentId
          } else if (tradeshortcutId) {
            params.tradeshortcutId = tradeshortcutId
          } else if (id) {
            params.escrowpaymentId = id
          }

          return {
            url: `/api/v2/bussines/transaction-detail/item-detail`,
            params,
          }
        },
      }),
      fetchTransactionNote: builder.query({
        query({ type, tradeshortcutId, escrowpaymentId }) {
          const params = { type }

          if (tradeshortcutId) params.tradeshortcutId = tradeshortcutId
          if (escrowpaymentId) params.escrowpaymentId = escrowpaymentId

          return {
            url: `/api/v1/bussines/transaction/note`,
            params,
          }
        },
      }),
      createTransactionNote: builder.mutation({
        query(body) {
          const { tradeshortcutId, escrowpaymentId, buyerNote, sellerNote } =
            body

          const data = {}
          if (tradeshortcutId) {
            data.tradeshortcutId = tradeshortcutId
          } else if (escrowpaymentId) {
            data.escrowpaymentId = escrowpaymentId
          }

          if (buyerNote) data.buyerNote = buyerNote
          if (sellerNote) data.sellerNote = sellerNote

          return {
            url: `/api/v1/bussines/transaction/note`,
            method: 'POST',
            body: data,
          }
        },
      }),
      rejectTransaction: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/bussines/transaction/reject/${id}`,
            method: 'POST',
          }
        },
      }),
      fetchTransactionAdjustment: builder.query({
        query({ type, escrowpaymentId, customerCode }) {
          const params = { type }

          if (escrowpaymentId) params.escrowpaymentId = escrowpaymentId
          if (customerCode) params.customerCode = customerCode

          return {
            url: `/api/v1/bussines/transaction/adjustment/invoice`,
            params,
          }
        },
      }),
      createAdjustment: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/transaction/adjustment`,
            method: 'POST',
            body,
          }
        },
        transformErrorResponse: (response) => {
          return (
            response.data?.message ||
            'Terjadi kesalahan saat mengajukan penyesuaian'
          )
        },
      }),
      confirmAdjustment: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/transaction/adjustment/confirm`,
            method: 'POST',
            body,
          }
        },
        transformErrorResponse: (response) => {
          return (
            response.data?.message ||
            'Terjadi kesalahan saat menolak penyesuaian'
          )
        },
      }),
      fetchAdjustmentBySeller: builder.query({
        query({ escrowpaymentId }) {
          return {
            url: `/api/v1/bussines/transaction/adjustment/adjustbyseller`,
            params: { escrowpaymentId },
          }
        },
      }),
      createAdjustmentSetDraft: builder.mutation({
        query(body) {
          return {
            url: API_ADJUSTMENT_SET_DRAFT,
            method: 'POST',
            body,
          }
        },
      }),
      fetchAdjustmentGetDraft: builder.mutation({
        query(body) {
          return {
            url: API_ADJUSTMENT_GET_DRAFT,
            method: 'POST',
            body,
          }
        },
      }),
      sellerConfirmPaymentCod: builder.mutation({
        query(body) {
          return {
            url: API_SELLER_CONFIRM_PAYMENT_COD,
            method: 'POST',
            body,
          }
        },
      }),
      editNoTrx: builder.mutation({
        query(body) {
          return {
            url: API_EDIT_NO_TRX,
            method: 'POST',
            body,
          }
        },
      }),
      editProject: builder.mutation({
        query(body) {
          return {
            url: API_EDIT_PROJECT,
            method: 'POST',
            body,
          }
        },
      }),
      sellerPaymentOnBehalf: builder.mutation({
        query(body) {
          return {
            url: API_TRANSACTION_PAYMENT,
            method: 'POST',
            body,
          }
        },
      }),
      archiveTransaction: builder.mutation({
        query(body) {
          return {
            url: API_TRANSACTION_ARCHIVE,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const {
  useFetchSaldoQuery,
  useFetchTransactionQuery,
  useLazyFetchTransactionQuery,
  useFetchTransactionSummaryQuery,
  useLazyFetchTransactionSummaryQuery,
  useFetchTransactionPicQuery,
  useLazyFetchTransactionPicQuery,
  useFetchProfileQuery,
  useFetchNotifQuery,
  useFetchInboxQuery,
  useFetchTransactionByIdQuery,
  useFetchTransactionItemDetailQuery,
  useLazyFetchTransactionItemDetailQuery,
  useFetchTransactionNoteQuery,
  useCreateTransactionNoteMutation,
  useRejectTransactionMutation,
  useFetchTransactionAdjustmentQuery,
  useCreateAdjustmentMutation,
  useConfirmAdjustmentMutation,
  useFetchReadInboxQuery,
  useLazyFetchReadInboxQuery,
  useFetchReadNotifMutation,
  useFetchReadAllNotifMutation,
  useFetchAdjustmentBySellerQuery,
  useCreateAdjustmentSetDraftMutation,
  useFetchAdjustmentGetDraftMutation,
  useSellerConfirmPaymentCodMutation,
  useSellerPaymentOnBehalfMutation,
  useEditNoTrxMutation,
  useEditProjectMutation,
  useArchiveTransactionMutation,
} = dashboardApiSlice
